export interface IBundleList {
    Items: IBundleListItem[];
    Total: number;
}

interface IBaseBundle {
    Name: string;
    BundleValue?: IBundleValue;
    Description: string;
    LogoImageID: number;
    ValidFrom?: Date;
    ValidTo?: Date;
}

export interface ICreateBundleRequest extends IBaseBundle {
    Components: IBundleComponentItem[];
}

export interface IBundleListItem extends IBaseBundle {
    ID: number;
}

export interface IBundleItem extends IBundleListItem {
    Components: IBundleComponentItemWithProducts[];
}

interface IBaseBundleComponentItem {
    Name: string;
    Quantity: number;
}

export interface IBundleComponentItem extends IBaseBundleComponentItem {
    VariationIDs: string[];
}

export interface IBundleComponentItemWithProducts extends IBaseBundleComponentItem {
    Variations: IBundleVariation[];
    errors?: IComponentErrors;
}

interface IComponentErrors {
    name: boolean;
    noVariations: boolean;
}

export interface IBundleVariation {
    VariationID: string;
    Title: string;
    ProductID: string;
    Price: number;
    ImageID: string;
    CategoryID?: number;
    ItemTypeID?: number;
    CurrencyCode?: string;
    CurrencySign?: string;
    Size?: string;
    Colour?: string;
    SizeName?: string;
    ColourName?: string;
}

export interface IItemType {
    ID: number;
    Name: string;
}

export interface ICategoryItems {
    Items: ICategory[];
}

export interface ICategory extends IItemType {
    ItemTypes: IItemType[];
}

export interface IItemTypeInModal extends IItemType {
    Counter: number;
}

export interface ICategoryInModal extends ICategory {
    Counter: number;
    ItemTypes: IItemTypeInModal[];
    IsOpen?: boolean;
}

export interface IBundleVariationInModal extends IBundleVariation {
    Selected: boolean;
    StockLevel: number;
    Disabled: boolean;
}

export interface ICategoryFilter {
    filter: number;
    searchTerm?: string;
}

export enum BundleTypeEnum {
    Fixed,
    Discount
}

export interface IBundleValue {
    Price?: number;
    DiscountPercent?: number;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/bundles/models/models.ts